import React from "react";

type SVGProps = React.SVGProps<SVGSVGElement>;

export const CaretRight = ({
  strokeWidth = "2",
  ...props
}: { strokeWidth?: string } & SVGProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1049_8108)">
      <path
        d="M6 3L11 8L6 13"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1049_8108">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(-1 0 0 -1 16 16)"
        />
      </clipPath>
    </defs>
  </svg>
);
